import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Inline, Link, Box, Text, Bleed, ButtonIcon, IconNewWindow } from "braid-design-system";
import { useJobUrl, jobUrlOriginValues } from "../JDVLayout/JDVLayout.mjs";
import { ShareMenu } from "../ShareMenu/ShareMenu.mjs";
import { translations } from "../../../components/OptionsBar/.vocab/index.mjs";
import { textHoverUnderline } from "./OptionsBar.css.mjs";
const OptionsBarView = ({
  job,
  onAnalyticsEvent = () => {
  },
  newTabUrl
}) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(Inline, { space: "medium", children: [
    /* @__PURE__ */ jsx(Link, { href: newTabUrl, target: "_blank", children: /* @__PURE__ */ jsx(
      Box,
      {
        component: "label",
        cursor: "pointer",
        className: textHoverUnderline,
        children: /* @__PURE__ */ jsxs(Inline, { space: "xsmall", alignY: "center", children: [
          /* @__PURE__ */ jsx(Text, { tone: "secondary", size: "small", children: t("New tab") }),
          /* @__PURE__ */ jsx(Box, { paddingX: "xsmall", children: /* @__PURE__ */ jsx(Bleed, { vertical: "xxsmall", children: /* @__PURE__ */ jsx(
            ButtonIcon,
            {
              id: "newTabButton",
              icon: /* @__PURE__ */ jsx(IconNewWindow, {}),
              label: t("New tab"),
              bleed: true
            }
          ) }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ jsx(ShareMenu, { job, onAnalyticsEvent, showText: true, bleed: true })
  ] });
};
const OptionsBar = ({
  job,
  jobUrlOpts,
  renderRelativePaths,
  onAnalyticsEvent
}) => {
  const newTabUrl = useJobUrl({
    id: job.id,
    jobUrlOpts,
    renderRelativePaths,
    overrideValues: {
      origin: jobUrlOriginValues.showNewTab
    }
  });
  const jobUrl = job.url || newTabUrl;
  return /* @__PURE__ */ jsx(
    OptionsBarView,
    {
      job,
      newTabUrl: jobUrl,
      onAnalyticsEvent
    }
  );
};
export {
  OptionsBar
};
